import PizzaDemo from "../../../Images/PizzaDemo2.jpg";
import PizzaDemo3 from "../../../Images/PizzaDemo3.jpg";
import "./Catalog.css";
import OfferCard from "../OfferCard/OfferCard";
import LoadingBar from "../Community/LoadingBar/LoadingBar";
import { useNavigate, useParams } from "react-router-dom";
import { useState, useEffect, useCallback } from "react";

import { userService } from "../../../_services";
import { useTranslation } from "react-i18next";
import LogoShow from "../Community/LogoShow/LogoShow";

export default function Catalog({ data }) {
    const params = useParams();
    const { i18n, t } = useTranslation();

    const [businessData, setBusinessData] = useState({});
    const [benefitData, setBenefitData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    console.log(params)

    useEffect(() => {
        const fetchMyAPI = async () => {
            if (!data) {
                setIsLoading(true);
                const business = await userService.getClubDetails(params.id);
                const benefits = await userService.getClubOffer(params.id);
                setBusinessData(business);
                setBenefitData(benefits);
                setIsLoading(false);
            } else {
                setBusinessData(data);
                setBenefitData(data.benefitsOfferList);
            }
        };
        fetchMyAPI();
    }, [data, params.id]);



    const changeLanguageEn = () => {
        i18n.changeLanguage("en");
    };

    const changeLanguageHe = () => {
        i18n.changeLanguage("he");
        console.log(i18n.language);
    };

    return (
        <div>
            <div className="catalog-page">
                {/* Hero Section */}
                <div className="hero-section">

                    {/*<div className="hero-image-container">*/}
                    {/*    <img*/}
                    {/*        src={businessData.largeLogoUrl}*/}
                    {/*        alt={businessData.name}*/}
                    {/*        className="hero-image"*/}
                    {/*    />*/}
                    {/*    <div className="hero-overlay">*/}
                    {/*        <h1 className="hero-title">{businessData.name}</h1>*/}
                    {/*        <p className="hero-subtitle">*/}
                    {/*            {t("ריכשו את ההצעות המיוחדות שלנו ותרוויחו תגמול על כל רכישה")}*/}
                    {/*        </p>*/}
                    {/*    </div>*/}
                    {/* </div>*/}
                    <div className="header">
                        <div className="textHeader">
                            <p>{businessData.name}</p>
                        </div>
                        <div className="logoHolder">
                            <div>
                                <img src={businessData?.picture_url} alt="" />
                            </div>
                        </div>
                    {/*<div className="hero-image-container">*/}
                    {/*    <img*/}
                    {/*        src={PizzaDemo}*/}
                    {/*        alt={businessData.name}*/}
                    {/*        className="hero-image"*/}
                    {/*    />*/}
                    {/*    <div className="hero-overlay">*/}
                    {/*        <h1 className="hero-title">{businessData.name}</h1>*/}
                    {/*        <p className="hero-subtitle">*/}
                    {/*            {t("ריכשו את ההצעות המיוחדות שלנו ותרוויחו תגמול על כל רכישה")}*/}
                    {/*        </p>*/}
                    {/*    </div>*/}
                    </div>
                </div>


                {/* Offers Grid */}
                <div dir="rtl" className="offers-section">
                    <h2 className="section-title">הטבות זמינות:</h2>
                    {isLoading && (
                        <LoadingBar text="הטבות" />
                    )}
                    {!isLoading && (
                        <div className="offers-grid">
                            {benefitData &&
                                benefitData.map((e, index) => (
                                    <OfferCard
                                        // data={{ ...e, smallPicturlUrl: PizzaDemo3 }}
                                        data={{ ...e, smallPicturlUrl: benefitData[index].smallPicturlUrl || PizzaDemo3 }}
                                        index={index}
                                        club={data} /// check what you want to pass
                                        key={index}
                                    />
                                ))}
                        </div>
                    )}
                </div>

            </div>
            <LogoShow />

        </div>
    );
}
